import { FinalWebhookStatus, ProcessingState } from '../../enum';
import { MerchantDto } from '../merchant.dto';
import { OrderDto } from '../order.dto';
import { EmployeeDto } from '../employee.dto';
import { PosDeviceDto } from '../posDevice.dto';

export class OrderCacheDto {
  id: number;
  surfboardOrderId: string;
  surfboardPaymentId: string;
  surfboardTerminalId: string;
  merchantId?: number;
  posDeviceId?: number;
  operatorEmployeeId?: number;
  orderId?: number;
  processingState: ProcessingState;
  isSuccess?: boolean;
  isDataLoss?: boolean;
  finalWebhookStatus?: FinalWebhookStatus;
  isFullyPaid?: boolean;
  payload?: any;
  user?: any;
  apiKey?: string;
  orderLink?: string;
  surfboardPaymentAmount?: number;
  createdDate?: Date;
  processedDate?: Date;
  failReason?: any;
  rawPaymentResponseBase64?: string;
  decodedPaymentResponse?: any;
  paymentResponseUpdatedDate?: Date
  webhooks?: any[];
  merchant?: Partial<MerchantDto>;
  posDevice?: Partial<PosDeviceDto>;
  operatorEmployee?: Partial<EmployeeDto>;
  order?: Partial<OrderDto>
}